import React from 'react';
import './characterswitch.css'
import pic24 from '../../assets/pic24.png'
import { Link } from 'react-router-dom';
import pic25 from '../../assets/pic25.png'
import pic32 from '../../assets/pic32.png'
const Charcterswitch = (props) => {
    return ( 
        <>
                         <section className='container-charcter'>
                                <img src={pic24} alt='floar'></img>
                                <img className='charcter-img' src={props.img} alt={props.alt}></img>
                                <div className='text-img-character'>
                                    <h2 className='character-name'>{props.name}</h2>
                                </div>

                                <div className='row-navs-buttons-character'>
                                    <button className='circlecta-cont' onClick={props.onPrev}>
                                        <img src={pic25} alt='left'></img>
                                    </button>
                                    <button className='circlecta-cont' onClick={props.onNext}>
                                        <img src={pic32} alt='right'></img>
                                    </button>
                                </div>
                         </section>
        </>
     );
}
 
export default Charcterswitch;